/**
 * PostListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostListReq
 */
export interface PostListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 帖子列表筛选 */
  filter_preset?: string
  /** 帖子类型 */
  type?: string
  /** 创建用户ID */
  create_user_id?: any
  /** 最小浏览量 */
  view_count__gte?: number
  /** 最小点赞数 */
  like_count__gte?: number
  /** 评论数范围 */
  comment_count__range?: string
  /** 发布时间距今 */
  published_at__since?: string
  /** 更新时间早于 */
  updated_at__before?: string
  /** 标题包含 */
  title__like?: string
  /** 内容包含 */
  content__like?: string
  /** 标签包含 */
  tags__contains?: string
  /** 类型列表 */
  type__in?: string[]
  /** 创建用户ID列表 */
  create_user_id__in?: any
}

/**
 * PostListReq Schema
 */
export const PostListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    filter_preset: {
      description: '帖子列表筛选',
      format: 'cons.PostListFilterPreset',
      type: 'string',
      label: '帖子列表筛选',
    },
    type: {
      description: '帖子类型',
      format: '*cons.PostType',
      type: 'string',
      label: '帖子类型',
    },
    create_user_id: {
      description: '创建用户ID',
      format: 'string',
      type: 'user',
      label: '创建用户ID',
    },
    view_count__gte: {
      description: '最小浏览量',
      format: '*int',
      type: 'integer',
      label: '最小浏览量',
    },
    like_count__gte: {
      description: '最小点赞数',
      format: '*int',
      type: 'integer',
      label: '最小点赞数',
    },
    comment_count__range: {
      description: '评论数范围',
      format: '*string',
      type: 'string',
      label: '评论数范围',
    },
    published_at__since: {
      description: '发布时间距今',
      format: '*string',
      type: 'string',
      label: '发布时间距今',
    },
    updated_at__before: {
      description: '更新时间早于',
      format: '*string',
      type: 'string',
      label: '更新时间早于',
    },
    title__like: {
      description: '标题包含',
      format: 'string',
      type: 'string',
      label: '标题包含',
    },
    content__like: {
      description: '内容包含',
      format: 'string',
      type: 'string',
      label: '内容包含',
    },
    tags__contains: {
      description: '标签包含',
      format: 'string',
      type: 'string',
      label: '标签包含',
    },
    type__in: {
      description: '类型列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '类型列表',
    },
    create_user_id__in: {
      description: '创建用户ID列表',
      format: '[]string',
      type: 'user',
      label: '创建用户ID列表',
    },
  },
  type: 'object',
}
